import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../useAppSelector";

export default function useStoreFlagError(storeSlug: string) {
  const [t] = useTranslation('common')

  const store = useAppSelector(state => state.get('userData').get('stores').find(store => store.get('slug') === storeSlug))

  return useMemo(() => {
    if(!store?.get('flagged')) return null;

    switch (store.get('error_slug')) {
      case 'store-not-found':
        return t("We couldn't find a store on your account. Make sure you create a store on {{store}} before your connect it with Art of Where.", { store: store.get('name') });
      case 'already-exists':
        return t("This {{store}} store is already linked to another Art of Where account. Please remove it from the other account first.", { store: store.get('name') });
      case 'peer-certificate-not-authenticated':
        return t("There is an issue with the SSL certificate configuration of your server that prevents us from establishing a connection to your {{store}} store. Please contact your server administrator and try connecting again.", { store: store.get('name') });
      case 'curl-url-malformed':
        return t("The URL for your {{store}} store seems invalid. Please double check that you are entering the correct URL, verify with your server administrator and try connecting again.", { store: store.get('name') });
      case 'curl-empty-reply':
        return t("There was a problem that prevented us from connecting to your {{store}} store. The connection to your server was successful, but your server returned an invalid response. Please try again later. If the problem persists, please contact your server administrator.", { store: store.get('name') });
      case 'syntax-error':
        return t("There was a problem that prevented us from connecting to your {{store}} store. There was a 'Syntax error' in the response from your server. Please contact your server administrator and try connecting again.", { store: store.get('name') });
      case 'payment-required':
        return t("Your {{store}} store subscription is inactive. Please reactivate it in {{store}}, then reconnect your store to Art of Where.", { store: store.get('name') });
      case 'store-expired':
        return t("Your store is currently expired and therefore cannot be connected to Art of Where. Please renew your {{store}} store subscription and try connecting again.", { store: store.get('name') });
      case 'store-suspended':
        return t("Your {{store}} store is currently suspended and therefore cannot be connected to Art of Where.", { store: store.get('name') });
      case 'curl-connect-error':
        return t("There was a problem connecting to your {{store}} store. Please try again later. If the problem persists, please contact your server administrator.", { store: store.get('name') });
      case 'route-not-found':
        return t("There seems to be a routing issue with your {{store}} setup. Please contact your server administrator.", { store: store.get('name') });
      case 'etsy-oauth1-deprecation':
        return t("Due to recent changes on the Etsy platform, you need to reconnect your store for the integration to work again.");
      default:
        return t("There was a problem that prevented us from connecting to your {{store}} store.", { store: store.get('name') });
    }
  }, [store, t])
}
